<template>
  <v-navigation-drawer
    v-model="drawer"
    fixed
    temporary
    large
    right
    width="30%"
    @input="onInput"
  >
    <div
      v-if="loading"
      class="info-progress-container"
    >
      <v-progress-circular
        size="100"
        :indeterminate="true"
        color="primary"
      />
    </div>
    <slot v-else />
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'InfoPane',
  components: {},
  props: {
    loading: { type: Boolean, default: false }
  },
  data: function () {
    return {
      drawer: true
    }
  },
  methods: {
    close() {
      this.$router.push({
        query: this.$route.query,
        name: this.$route.name.replace('.info', '')
      })
    },
    onInput(isOpen) {
      if (!isOpen) {
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-navigation-drawer--temporary {
  max-width: 30rem;
}
.info-progress-container {
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
}
</style>
